import React from 'react';

import {
    userNotificationsSidebarSection,
    userNotificationsSidebarSectionGrown,
} from '../../user-notifications.module.styl';

type Props = {
    children: React.ReactNode | React.ReactNode[],
    grow?: boolean,
};

export const SidebarSection = ({children, grow}: Props) => {
    return (
        <div className={`${userNotificationsSidebarSection} ${grow ? userNotificationsSidebarSectionGrown : ''}`}>
            {children}
        </div>
    );
};
